'use strict';

import fullScreenGallery from './full-screen-gallery';
import {debounce} from '../utils/debounce';

const classNames = {
	arrow: 'arrow',
	button: 'button',
	carousel: 'carousel',
	image: 'image',
	imagesContainer: 'images-container',
	previewSlider: 'preview-slider'
};

const modifiers = {
	loaded: 'loaded',
	next: 'next',
	prev: 'prev',
	modifiers: 'scroll'
};

const sliderAnimationSpeed = 200;

let ui = {
	init: () => {
		const $previewSlider = $.findByBem(classNames.previewSlider);
		const $imagesContainer = carousel.getImagesContainer();
		const imageIndex = $previewSlider.data('main-image-index');
		const $images = $imagesContainer.findByBem(classNames.previewSlider, classNames.image);

		if ($images.length < 5) {
			ui.disableInfiniteCarousel();
			$previewSlider.addBemClass(classNames.previewSlider, null, modifiers.loaded);
			return;
		}

		for (let i = 0; i < imageIndex; i++) {
			const firstImage = $images[i];
			$imagesContainer.append(firstImage);
		}

		$previewSlider.addBemClass(classNames.previewSlider, null, modifiers.loaded);

		const debounceDelayMilliseconds = 200;
		$previewSlider.findByBem(classNames.previewSlider, classNames.button, modifiers.prev).bind('click', 
			debounce(() => {
				carousel.previousImage();
			}, debounceDelayMilliseconds)
		);
		
		$previewSlider.findByBem(classNames.previewSlider, classNames.button, modifiers.next).bind('click', 
			debounce(() => {
				carousel.nextImage();
			}, debounceDelayMilliseconds)
		);
		
	},

	disableInfiniteCarousel: () => {
		$.findByBem(classNames.previewSlider, classNames.button).hide();
	}
};

let carousel = {
	previousImage: () => {
		const $previewImagesContainer = carousel.getImagesContainer();
		const $allImages = $previewImagesContainer.findByBem(classNames.previewSlider, classNames.image);
		carousel.shiftImagesDown($allImages, $previewImagesContainer);
	},

	nextImage: () => {
		const $previewImagesContainer = carousel.getImagesContainer();
		const $allImages = $previewImagesContainer.findByBem(classNames.previewSlider, classNames.image);
		carousel.shiftImagesUp($allImages, $previewImagesContainer);
	},

	getImagesContainer: () => {
		const $layoutSlider = $.findByBem(classNames.previewSlider);
		const $result = $layoutSlider.findByBem(classNames.previewSlider, classNames.imagesContainer);
		return $result;
	},

	shiftImagesUp: ($allImages, $imagesContainer) => {
		if ($allImages.length === 0) {
			return;
		}

		const firstImage = $allImages[0];
		const imageHeight = $(firstImage).height();

		$imagesContainer.animate({'margin-top': -imageHeight}, sliderAnimationSpeed, () => {
			$imagesContainer.append(firstImage);
			$imagesContainer.css('margin-top', '');
		});

		fullScreenGallery.initOpenGallery(firstImage);
	},

	shiftImagesDown: ($allImages, $imagesContainer) => {
		if ($allImages.length === 0) {
			return;
		}
		
		const lastImage = $allImages[$allImages.length - 1];
		const imageHeight = $(lastImage).height();

		$(lastImage).remove().css({'margin-top': -imageHeight});
		$imagesContainer.prepend($allImages[$allImages.length - 1]);
		$(lastImage).animate({'margin-top': ''}, sliderAnimationSpeed, () => {
			$(lastImage).removeAttr('style');
		});

		fullScreenGallery.initOpenGallery(lastImage);
	}
}

export default {
	init() {
		ui.init();
	}
}
